import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Table } from "react-bootstrap";
import { Card } from "react-bootstrap";
import NumberFormat from "react-number-format";
import {
  CustomOutlinedDisabledTextField,
  CustomOutlinedDisabledCurrencyField,
} from "../../../../../../partials/content/Forms";
import { Badge } from "react-bootstrap";
import { getTransferDetail } from "../../../../../../services/inventory/itemsMovement";
import { formatDate } from "../../../../../../utils/utils";
import { Typography } from "@material-ui/core";
import { Editor } from "primereact/editor";
import { DialogActions } from "@material-ui/core";
import { DateTime } from "luxon";
import BootstrapTooltip from "../../../../../../partials/content/BootstrapTooltip";
import Illustration from "../../../../../../partials/content/Illustration";
function ItemsTransferDetail({ transferID, onCloseDialog }) {
  const [transferData, setTransferData] = useState({
    ID: 0,
    fromLocation: "",
    toLocation: "",
    moveDate: DateTime.now().startOf("day"),
    currency: {
      currencyCode: "",
    },
    totalCost: 0,
    grStatusDesc: "",
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndex1, setActiveIndex1] = useState(0);
  useEffect(() => {
    getTransferDetailData(transferID);
  }, [transferID]);
  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="Items Transfer Main" rightIcon="fas fa-th-large">
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Items Transfer Header</strong>
                      </span>
                      <Badge
                        className="float-right ml-1"
                        variant={
                          transferData.grStatus === 1
                            ? "primary"
                            : transferData.grStatus === 2
                            ? "warning"
                            : transferData.grStatus === 3
                            ? "success"
                            : transferData.grStatus === 9
                            ? "danger"
                            : null
                        }
                      >
                        {transferData.grStatus !== 0
                          ? "Goods " + transferData.grStatusDesc
                          : null}
                      </Badge>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Movement Date"
                            value={formatDate(transferData.moveDate)}
                          />
                          <CustomOutlinedDisabledTextField
                            label="From Location"
                            value={transferData.fromLocation}
                          />
                          <CustomOutlinedDisabledTextField
                            label="To Location"
                            value={transferData.toLocation}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Currency"
                            value={transferData.currency.currencyCode}
                          />
                          <CustomOutlinedDisabledCurrencyField
                            label="Transfer Cost"
                            value={transferData.totalCost}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="accordion mb-3">
                <div className="card">
                  <Accordion
                    className="accordion"
                    activeIndex={activeIndex}
                    onTabChange={(e) => {
                      setActiveIndex(e.index);
                    }}
                  >
                    <AccordionTab
                      header={
                        <React.Fragment>
                          <i className="fas fa-sitemap"></i>
                          <span>
                            <strong>Transfer Items</strong>
                          </span>
                        </React.Fragment>
                      }
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="card">
                            <Table striped borderless size="sm" responsive="xl">
                              {transferData.itemsTransfer &&
                              transferData.itemsTransfer.length > 0 ? (
                                <thead>
                                  <tr>
                                    <th>
                                      <Typography className="mx-1 kt-font-bolder">
                                        Item Name
                                      </Typography>
                                    </th>
                                    <th>
                                      <Typography className="mx-1 kt-font-bolder">
                                        Quantity
                                      </Typography>
                                    </th>
                                    <th>
                                      <Typography className="mx-1 kt-font-bolder">
                                        Unit
                                      </Typography>
                                    </th>
                                    <th>
                                      <Typography className="mx-1 kt-font-bolder">
                                        Batch ID
                                      </Typography>
                                    </th>
                                  </tr>
                                </thead>
                              ) : null}
                              <tbody>
                                {transferData.itemsTransfer &&
                                transferData.itemsTransfer.length > 0 ? (
                                  transferData.itemsTransfer.map(
                                    (item, index) => {
                                      return (
                                        <tr key={index} className="border-top">
                                          <td>
                                            <Typography className="mx-1 my-1">
                                              {item.itemType > 0 ? (
                                                <span>
                                                  <BootstrapTooltip
                                                    title={item.itemTypeName}
                                                  >
                                                    <span className="mr-2">
                                                      <i
                                                        className={
                                                          item.itemType === 1
                                                            ? "fas fa-boxes text-success"
                                                            : item.itemType ===
                                                              2
                                                            ? "fas fa-tools text-primary"
                                                            : item.itemType ===
                                                              3
                                                            ? "fas fa-building text-info"
                                                            : item.itemType ===
                                                              4
                                                            ? "fas fa-boxes text-warning"
                                                            : item.itemType ===
                                                              5
                                                            ? "fas fa-boxes text-danger"
                                                            : null
                                                        }
                                                      ></i>
                                                    </span>
                                                  </BootstrapTooltip>
                                                  <span>
                                                    {item.itemCode}{" "}
                                                    {item.itemName}
                                                  </span>
                                                </span>
                                              ) : (
                                                <React.Fragment>
                                                  {item.itemCode}{" "}
                                                  {item.itemName}
                                                </React.Fragment>
                                              )}
                                            </Typography>
                                          </td>
                                          <td>
                                            <Typography className="mx-1 my-1">
                                              {item.qty}
                                            </Typography>
                                          </td>
                                          <td>
                                            <Typography className="mx-1 my-1">
                                              {item.uom.uomName}
                                            </Typography>
                                          </td>
                                          <td>
                                            <Typography className="mx-1 my-1">
                                              {item.batchID}
                                            </Typography>
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      className="text-center py-3"
                                      colSpan="4"
                                    >
                                      <Illustration
                                        imageSource="INVIFO Inventory.png"
                                        guidance="You don't have any Transfer items yet"
                                        guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                        size="sm"
                                      ></Illustration>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
              {transferData.itemsTransferCost ? (
                <div className="accordion">
                  <div className="card">
                    <Accordion
                      className="accordion"
                      activeIndex={activeIndex1}
                      onTabChange={(e) => {
                        setActiveIndex1(e.index);
                      }}
                    >
                      <AccordionTab
                        header={
                          <React.Fragment>
                            <i className="far fa-money-bill-alt"></i>
                            <span>
                              <strong>Transfer Cost Items</strong>
                            </span>
                          </React.Fragment>
                        }
                      >
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="card">
                              <Table
                                striped
                                borderless
                                size="sm"
                                responsive="xl"
                              >
                                {transferData.itemsTransferCost &&
                                transferData.itemsTransferCost.length > 0 ? (
                                  <thead>
                                    <tr>
                                      <th>
                                        <Typography className="mx-1 kt-font-bolder">
                                          Cost Name
                                        </Typography>
                                      </th>
                                      <th>
                                        <Typography className="mx-1 kt-font-bolder text-right">
                                          Cost
                                        </Typography>
                                      </th>
                                    </tr>
                                  </thead>
                                ) : null}
                                <tbody>
                                  {transferData.itemsTransferCost &&
                                  transferData.itemsTransferCost.length > 0 ? (
                                    transferData.itemsTransferCost.map(
                                      (cost, index) => {
                                        return (
                                          <tr key={index}>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {cost.costName}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography
                                                component="div"
                                                className="mx-1 my-1"
                                              >
                                                <NumberFormat
                                                  value={cost.cost}
                                                  displayType={"text"}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  renderText={(value) => (
                                                    <div className="float-right">
                                                      {
                                                        transferData.currencyCode
                                                      }{" "}
                                                      {value}
                                                    </div>
                                                  )}
                                                />
                                              </Typography>
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )
                                  ) : (
                                    <tr>
                                      <td
                                        className="text-center py-3"
                                        colSpan="2"
                                      >
                                        <Illustration
                                          imageSource="INVIFO Sales.png"
                                          guidance="You don't have any Transfer Cost items yet"
                                          guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                          size="sm"
                                        ></Illustration>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </div>
                      </AccordionTab>
                    </Accordion>
                  </div>
                </div>
              ) : null}
            </TabPanel>
            <TabPanel header={"Note"} rightIcon="fas fa-sticky-note">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        value={transferData.note}
                        placeholder="Type your notes here..."
                        readOnly={true}
                        className="editor-grey"
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseDialog();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
      </DialogActions>
    </React.Fragment>
  );

  async function getTransferDetailData(transferID) {
    const response = await getTransferDetail(transferID);
    const { data } = response.data;
    setTransferData(data.transferData);
  }
}

export default ItemsTransferDetail;
